import React from "react";
import { usePermitted } from "../common/components/permissions/permissions";
import CompanyWhitelistManager from "../admin/trading/companyWhitelists/companyWhitelistManager";

const CompanyWhitelistPage = () => {
  const canQueryAllWhitelists = usePermitted([
    "api-query-company-whitelists",
    "api-manage-company-whitelists",
  ]);
  const allowEdit = usePermitted([
    "api-manage-own-company-whitelists",
    "api-manage-company-whitelists",
  ]);

  return (
    <CompanyWhitelistManager
      delegated={!canQueryAllWhitelists}
      allowEdit={allowEdit}
    />
  );
};

export default CompanyWhitelistPage;